export default class MerchantFieldLabel {
    public Value: string;
    public Default: string;

    constructor(value: string) {
        this.Value = value;
        this.Default = value;
    }
}
